<template>
  <q-form ref="editForm">
    <c-card title="상세정보" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline>
          <!-- 결재요청/결재처리 팝업(isApprContent)에서는 저장 버튼만 표시 -->
          <c-appr-btn
            v-if="!isApprContent"
            ref="appr-btn"
            :editable="editable"
            :approvalInfo="approvalInfo"
            @beforeApprAction="approvalRiskAssess"
            @callbackApprAction="approvalRiskAssessCallback"
            @requestAfterAction="getDetail"
          />
          <!-- 결재취소 (결재완료된 평가만) -->
          <c-btn
            v-if="!isApprContent && editable && isOld && disabled"
            label="결재취소"
            icon="undo"
            color="grey-8"
            @btnClicked="cancelApproval"
          />
          <c-btn
            v-if="!isApprContent && btnEditable && !isOld"
            label="지난 위험성평가 가져오기"
            icon="system_update_alt"
            @btnClicked="loadAssessPlan"
          />
          <!-- 그래프 (완료된 평가만) -->
          <c-btn
            v-if="!isApprContent && isOld && disabled && editable"
            label="그래프"
            icon="pie_chart"
            color="grey-8"
            @btnClicked="openRiskChart"
          />
          <!-- 출력 (완료된 평가만) -->
          <c-btn
            v-if="!isApprContent && isOld && disabled && editable"
            label="LBL0000312"
            icon="print"
            @btnClicked="print"
          />
          <c-btn
            v-if="!isApprContent && btnEditable && isOld"
            label="삭제"
            icon="remove"
            @btnClicked="removePlan"
          />
          <c-btn
            v-if="btnEditable"
            :isSubmit="isSave"
            :url="saveUrl"
            :param="assessPlan"
            :mappingType="mappingType"
            label="저장"
            icon="save"
            @beforeAction="saveAssessPlan"
            @btnCallback="saveCallback"
          />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            :required="true"
            :editable="editable"
            :disabled="disabled"
            label="평가명"
            name="assessmentName"
            v-model="assessPlan.assessmentName"
          >
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            required
            :editable="editable && !isOld"
            codeGroupCd="JOB_CATEGORY_CD"
            type="edit"
            itemText="codeName"
            itemValue="code"
            label="대상직군"
            name="jobCategoryCd"
            v-model="assessPlan.jobCategoryCd"
            @datachange="getScenarioItems"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :required="true"
            :editable="editable"
            :disabled="disabled"
            :range="true"
            label="평가기간"
            name="period"
            v-model="assessPlan.assessmentPeriod"
            @datachange="periodChange"
          />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :required="true"
            :editable="editable"
            :disabled="disabled"
            default="today"
            type="year"
            label="평가년도"
            name="assessmentYear"
            v-model="assessPlan.assessmentYear"
          />
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :required="true"
            :editable="editable"
            :disabled="disabled"
            codeGroupCd="RAM_ASSESS_TYPE_CD"
            type="edit"
            itemText="codeName"
            itemValue="code"
            name="ramAssessTypeCd"
            label="평가구분"
            v-model="assessPlan.ramAssessTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-field
            :required="true"
            :editable="editable"
            :disabled="disabled"
            :data="assessPlan"
            deptValue="assessmentManageDeptCd"
            type="dept_user"
            label="주관자"
            name="assessmentManageUserId"
            v-model="assessPlan.assessmentManageUserId"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant
            :required="true"
            :disabled="disabled"
            :editable="editable"
            type="edit"
            name="plantCd"
            v-model="assessPlan.plantCd"
          />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            :editable="editable"
            :disabled="true"
            label="LBLREGUSERNDATE"
            name="request"
            v-model="request"
          >
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-dept-multi
            :required="true"
            :editable="editable"
            :disabled="disabled"
            :parentCheckDepts="assessPlan.deptCd"
            label="평가부서"
            name="deptCd"
            v-model="assessPlan.deptCd"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-textarea
            :editable="editable"
            :disabled="disabled"
            label="상세내용"
            name="remark"
            v-model="assessPlan.remark"
          >
          </c-textarea>
        </div>
      </template>
    </c-card>
    <div class="row">
      <div class="col-6">
        <c-upload
          class="q-pt-md"
          :attachInfo="attachInfo"
          :editable="editable && !disabled"
        >
        </c-upload>
      </div>
      <div class="col-6">
        <c-table
          title="위험수준 판단기준"
          tableId="riskOfficeLevelGuide"
          :columns="guideGrid.columns"
          :data="guideGrid.data"
          gridHeight="200px"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :isExcelDown="false"
          :isFullScreen="false"
          :hideBottom="true"
        />
      </div>
    </div>
    <c-table
      ref="table"
      title="시나리오 목록"
      tableId="riskOfficeScenario"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="assessPlan.scenarios"
      :gridHeightAuto="true"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable && !disabled"
    >
      <template v-slot:table-chip>
        <span v-if="!isOld && assessPlan.scenarios.length === 0" class="q-ml-md text-blue" style="font-size: 0.92em"
          >✔️ 대상직군을 지정해야 해당 평가항목이 표시됩니다.</span
        >
        <span v-if="!isOld" class="q-ml-md text-blue" style="font-size: 0.92em"
          >✔️ 개선은 평가 저장 후 등록 가능합니다.</span
        >
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'customCol'">
          <component
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="
              editable && !disabled && Boolean(props.row.riskOfficeResultId)
            "
            :isImmShow="true"
            :requestContentsCols="[
              'categoryFst',
              'categorySnd',
              'categoryTrd',
              'riskLevelName',
              'riskBookFlag',
              'assessUserName',
            ]"
            tableKey="riskOfficeResultId"
            ibmTaskTypeCd="ITT0000025"
            ibmTaskUnderTypeCd="ITTU000040"
            @imprChange="imprChange"
          />
        </template>
      </template>
    </c-table>
    <c-table
      v-if="isOld"
      ref="docTable"
      title="관련자료"
      tableId="riskOfficeRelatedDocument"
      gridHeight="300px"
      :columns="docGrid.columns"
      :data="assessPlan.relatedDocuments"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable && !disabled"
      selection="multiple"
      rowKey="ramRelatedDocumentId"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group v-if="!isApprContent" outline>
          <c-btn
            v-if="btnEditable"
            label="직접추가"
            icon="add"
            @btnClicked="addEtc"
          />
          <c-btn
            v-if="btnEditable"
            label="LBLADD"
            icon="add"
            @btnClicked="addRelateDocument"
          />
          <c-btn
            v-if="btnEditable"
            :disabled="
              !assessPlan.relatedDocuments ||
              assessPlan.relatedDocuments.length === 0
            "
            label="LBLREMOVE"
            icon="remove"
            @btnClicked="deleteRelateDocument"
          />
        </q-btn-group>
      </template>
    </c-table>
    <q-dialog persistent v-model="isRiskChartOpen">
      <q-card class="menu-card" style="width: 600px; max-width: 90vw">
        <q-card-section
          class="row items-center q-pb-none px-2 py-1 bg-grey-8 text-white"
        >
          <div>위험수준별 시나리오 현황 (%)</div>
          <q-space></q-space>
          <q-btn icon="close" flat round dense v-close-popup></q-btn>
        </q-card-section>
        <q-separator></q-separator>
        <q-card-section class="p-2">
          <apexchart
            ref="riskChart"
            height="400"
            :width="riskChart.chartWidth"
            :options="riskChart.chartOptions"
            :series="riskChart.series"
          >
          </apexchart>
        </q-card-section>
      </q-card>
    </q-dialog>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from "quasar";
import VueApexCharts from "vue-apexcharts";
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "riskOfficeInfo",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: "",
        vendorFlag: false,
        ramTechniqueCd: "",
        officeCompleteFlag: "",
      }),
    },
    assessPlan: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: "",
        assessmentPeriod: [],
        scenarios: [],
      }),
    },
    attachInfo: {
      type: Object,
      default: () => ({
        isSubmit: "",
        taskClassCd: "RISK_PLAN",
        taskKey: "",
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contentHeight: null,
  },
  data() {
    return {
      guideGrid: {
        columns: [
          {
            name: "level",
            field: "level",
            label: "위험수준",
            align: "center",
            style: "width:120px",
            sortable: false,
          },
          {
            // CTable 기본 pagination 의 sortBy 가 "desc" 라 컬럼명이 겹치면 정렬됨
            name: "standard",
            field: "standard",
            label: "판단기준",
            align: "left",
            sortable: false,
          },
        ],
        data: [
          {
            level: "상",
            standard: "법규 위반 가능성이 높거나 사고 발생 시 중상이 예상됨.",
          },
          {
            level: "중",
            standard: "불편함을 초래하여 잠재적 질환 우려가 있음.",
          },
          { level: "하", standard: "경미한 위험이나 현재 관리가 잘되고 있음." },
        ],
      },
      grid: {
        merge: [
          { index: 0, colName: "categoryFst" },
          { index: 1, colName: "categorySnd" },
        ],
        columns: [
          {
            name: "categoryFst",
            field: "categoryFst",
            label: "대분류",
            align: "left",
            style: "width:120px",
            sortable: false,
          },
          {
            name: "categorySnd",
            field: "categorySnd",
            label: "중분류",
            align: "left",
            style: "width:120px",
            sortable: false,
          },
          {
            name: "categoryTrd",
            field: "categoryTrd",
            label: "소분류",
            align: "left",
            // style: "width:300px",
            sortable: false,
          },
          {
            name: "riskLevelCd",
            field: "riskLevelCd",
            label: "위험수준",
            align: "center",
            style: "width:100px",
            sortable: false,
            type: "select",
            itemText: "codeName",
            itemValue: "code",
            codeGroupCd: "RAM_RISK_LEVEL_CD",
            isChip: true,
            setHeader: true,
          },
          {
            name: "riskBookFlag",
            field: "riskBookFlag",
            label: "위험등록부",
            align: "center",
            style: "width:80px",
            sortable: false,
            type: "check",
            true: "Y",
            false: "N",
          },
          // {
          //   name: "remark",
          //   field: "remark",
          //   label: "개선계획",
          //   align: "left",
          //   style: "width:200px",
          //   sortable: false,
          //   type: "text",
          // },
          {
            name: "customCol",
            field: "customCol",
            label: "개선",
            align: "center",
            style: "width:200px",
            type: "custom",
            sortable: false,
          },
          {
            name: "assessDate",
            field: "assessDate",
            label: "평가일",
            align: "center",
            style: "width:120px",
            sortable: false,
            type: "date",
            setHeader: true,
          },
          {
            name: "assessUserName",
            field: "assessUserName",
            label: "평가자",
            align: "center",
            style: "width:100px",
            sortable: false,
            type: "user",
            userId: "assessUserId",
            setHeader: true,
          },
        ],
      },
      docGrid: {
        columns: [
          {
            name: "ramDocumentTypeName",
            field: "ramDocumentTypeName",
            label: "LBLCLASSIFICATION",
            align: "center",
            style: "width:10%",
            sortable: false,
          },
          {
            name: "documentTitle",
            field: "documentTitle",
            description: "documentSubTitle",
            label: "LBLTITLE",
            align: "left",
            style: "width:40%",
            sortable: false,
          },
          {
            name: "materialName",
            field: "materialName",
            label: "자료명",
            align: "left",
            style: "width:40%",
            type: "text",
            sortable: false,
            required: true,
          },
          {
            name: "attach",
            field: "attach",
            label: "LBLATTACHMENT",
            align: "center",
            style: "width:10%",
            type: "attach",
            taskClassCd: "RSA_RELATE_INFO",
            keyText: "ramRelatedDocumentId",
            sortable: false,
          },
        ],
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "60%",
        param: {},
        closeCallback: null,
      },
      isRiskChartOpen: false,
      riskChart: {
        chartOptions: {
          chart: {
            type: "pie",
          },
          colors: [],
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
          legend: {
            position: "right",
            horizontalAlign: "center",
            fontSize: "14px",
            markers: {
              width: 14,
              height: 14,
            },
            itemMargin: {
              vertical: 6,
            },
          },
        },
        series: [],
        chartWidth: "100%",
      },
      editable: true,
      saveUrl: "",
      deleteUrl: "",
      approvalUrl: "",
      deleteRelateDocumentUrl: "",
      isSave: false,
      isApproval: false,
      mappingType: "POST",
    };
  },
  computed: {
    isOld() {
      return Boolean(this.assessPlan.ramRiskAssessmentPlanId);
    },
    // 결재상세화면(결재함)에서 열린 경우
    isApprContent() {
      return Boolean(this.popupParam.isApprContent);
    },
    // 결재중(ASC0000001) 여부
    isApproving() {
      return this.assessPlan.approvalStatusCd === "ASC0000001";
    },
    // 저장/삭제 버튼 활성화 기준
    btnEditable() {
      return this.editable && !this.disabled && !this.isApproving;
    },
    approvalInfo() {
      return {
        sysApprovalRequestId: this.assessPlan.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.assessPlan.approvalStatusCd,
        apprEditable: this.isOld && !this.disabled, // 결재버튼 활성화 기준
        param: this.assessPlan, // 결재 param
        approvalUrl: this.approvalUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: "APTC000027", // 결재유형코드
        approvalParamValue: {
          // 결재상세화면 파라미터
          ramRiskAssessmentPlanId: this.assessPlan.ramRiskAssessmentPlanId,
          officeCompleteFlag: this.assessPlan.officeCompleteFlag,
          ramTechniqueCd: this.popupParam.ramTechniqueCd,
          isApprContent: true,
        },
        approvalRequestName:
          this.assessPlan.assessmentName +
          " (" +
          this.assessPlan.assessmentStartDate +
          "~" +
          this.assessPlan.assessmentEndDate +
          ") " +
          this.assessPlan.deptName, // 결재요청명 (문서 title)
        approvalConnId: this.assessPlan.ramRiskAssessmentPlanId, // 결재연결용 업무일련번호 (문서 key)
      };
    },
    // request() {
    //   return this.assessPlan.regUserName + " / " + this.assessPlan.regDtStr;
    // },
    // 개선요청 Component
    imprComponent() {
      let components = () => import(`${"@/pages/common/ibm/tableImpr.vue"}`);
      return components;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.saveUrl = transactionConfig.ram.assessPlan.insert.url;
      this.deleteUrl = transactionConfig.ram.assessPlan.delete.url;
      // 결재요청 전 저장 (c-appr-btn 이 PUT 으로 assessPlan 저장 후 callbackApprAction 발생)
      this.approvalUrl = transactionConfig.ram.assessPlan.update.url;
      this.deleteRelateDocumentUrl =
        transactionConfig.ram.relatedDocument.delete.url;
    },
    getDetail() {
      // 상세조회는 부모(riskDetail)에서 처리
      this.$emit("getDetail");
    },
    periodChange() {
      if (
        this.assessPlan.assessmentPeriod &&
        this.assessPlan.assessmentPeriod.length === 2 &&
        this.assessPlan.assessmentPeriod[0]
      ) {
        this.$set(
          this.assessPlan,
          "assessmentYear",
          this.$comm.moment(this.assessPlan.assessmentPeriod[0]).format("YYYY"),
        );
      }
    },
    saveAssessPlan() {
      if (this.assessPlan.ramRiskAssessmentPlanId) {
        this.saveUrl = transactionConfig.ram.assessPlan.update.url;
        this.mappingType = "PUT";
      } else {
        this.saveUrl = transactionConfig.ram.assessPlan.insert.url;
        this.mappingType = "POST";
        this.assessPlan.officeCompleteFlag = "N"; // 평가계획
      }

      this.$refs["editForm"].validate().then((_result) => {
        if (
          _result &&
          this.$comm.validTable(this.grid.columns, this.assessPlan.scenarios) &&
          this.$comm.validTable(
            this.docGrid.columns,
            this.assessPlan.relatedDocuments,
            "관련자료",
            true, // 관련자료가 없어도 저장 가능
          )
        ) {
          window.getApp.$emit("CONFIRM", {
            title: "확인",
            message: "저장하시겠습니까?", // 저장하시겠습니까?
            type: "info", // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.assessPlan.regUserId = this.$store.getters.user.userId;
              this.assessPlan.chgUserId = this.$store.getters.user.userId;
              [
                this.assessPlan.assessmentStartDate,
                this.assessPlan.assessmentEndDate,
              ] = this.assessPlan.assessmentPeriod;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else if (!_result) {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      // 신규 저장 시 상위(riskDetail)에 평가 일련번호 전달 → 개선 탭 표시
      this.$emit("keySetting", result.data);
      this.$set(this.attachInfo, "taskKey", result.data);
      this.$set(this.attachInfo, "isSubmit", uid());
      this.getDetail();
      this.$emit(
        "apprTitle",
        this.assessPlan.assessmentName +
          " (" +
          this.assessPlan.assessmentStartDate +
          "~" +
          this.assessPlan.assessmentEndDate +
          ") " +
          this.assessPlan.deptName,
      );
    },
    // 위험수준 라벨 (백엔드 컬럼 별칭이 무엇이든 첫 문자열 값을 사용)
    riskLevelLabel(row) {
      let label = row.riskLevelName || row.risk || row.riskLevel || row.level;
      return label ? String(label) : "";
    },
    // 상:레드 / 중:오렌지 / 하:그린, 그 외에는 백엔드 color 값
    riskLevelColor(row) {
      let colorByLevel = {
        상: "#e53935",
        중: "#fb8c00",
        하: "#43a047",
      };
      return colorByLevel[this.riskLevelLabel(row)] || row.color || "#b0b0b0";
    },
    openRiskChart() {
      this.$http.url = this.$format(
        selectConfig.ram.office.riskChart.url,
        this.assessPlan.ramRiskAssessmentPlanId,
      );
      this.$http.type = "GET";
      this.$http.request((_result) => {
        // 위험도별 발굴 현황
        let _data = _result.data || [];
        let labels = this.$_.map(_data, (row) => this.riskLevelLabel(row));
        let colors = this.$_.map(_data, (row) => this.riskLevelColor(row));
        // options 를 새 객체로 교체해야 vue-apexcharts 의 watch 가 감지한다
        this.$set(
          this.riskChart,
          "chartOptions",
          this.$_.assign({}, this.riskChart.chartOptions, {
            labels: labels,
            colors: colors,
            fill: { colors: colors },
          }),
        );
        this.$set(
          this.riskChart,
          "series",
          this.$_.map(_data, (row) => Number(row.cnt) || 0),
        );

        this.isRiskChartOpen = true;
        this.$nextTick(() => {
          if (this.$refs["riskChart"]) {
            this.$refs["riskChart"].refresh();
          }
        });
      });
    },
    print() {
      this.$http.url = this.$format(
        selectConfig.ram.office.print.url,
        this.assessPlan.ramRiskAssessmentPlanId,
      );
      this.$http.type = "GET";
      this.$http.request(
        (_result) => {
          let excelName = this.assessPlan.assessmentName
            ? this.assessPlan.assessmentName
            : this.$comm.getToday();
          let fileOrgNm = "사무직위험성평가_" + excelName + ".xlsx";
          let blob = this.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        },
        () => {},
      );
    },
    cancelApproval() {
      window.getApp.$emit("CONFIRM", {
        title: "확인",
        message:
          "결재정보를 삭제하고 작성중 상태로 변경합니다.\n진행하시겠습니까?",
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = transactionConfig.ram.assessPlan.officeCancel.url;
          this.$http.type = "PUT";
          this.$http.param = {
            ramRiskAssessmentPlanId: this.assessPlan.ramRiskAssessmentPlanId,
            chgUserId: this.$store.getters.user.userId,
          };
          this.$http.request(() => {
            window.getApp.$emit("APP_REQUEST_SUCCESS");
            this.getDetail(); // 부모(riskDetail)에서 완료여부 해제 후 재조회
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    removePlan() {
      window.getApp.$emit("CONFIRM", {
        title: "확인",
        message: "삭제하시겠습니까?",
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(
            this.deleteUrl,
            this.assessPlan.ramRiskAssessmentPlanId,
          );
          this.$http.type = "DELETE";
          this.$http.request(() => {
            window.getApp.$emit("APP_REQUEST_SUCCESS");
            this.$emit("closePopup");
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    approvalRiskAssess() {
      this.$refs["editForm"].validate().then((_result) => {
        if (!_result) {
          window.getApp.$emit("APP_VALID_ERROR");
          return;
        }
        if (
          !this.$comm.validTable(
            this.grid.columns,
            this.assessPlan.scenarios,
          ) ||
          !this.$comm.validTable(
            this.docGrid.columns,
            this.assessPlan.relatedDocuments,
            "관련자료",
            true,
          )
        ) {
          return;
        }
        window.getApp.$emit("CONFIRM", {
          title: "확인",
          message:
            "결재요청 하기 전 입력된 값을 저장합니다.\n\r 진행하시겠습니까?",
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.assessPlan.regUserId = this.$store.getters.user.userId;
            this.assessPlan.chgUserId = this.$store.getters.user.userId;
            [
              this.assessPlan.assessmentStartDate,
              this.assessPlan.assessmentEndDate,
            ] = this.assessPlan.assessmentPeriod;
            // 저장 실행 → 완료 후 approvalRiskAssessCallback 에서 결재요청 팝업
            this.isApproval = !this.isApproval;
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      });
    },
    approvalRiskAssessCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      // 저장된 내용으로 다시 조회 (신규 행 editFlag 초기화)
      this.getDetail();
      this.$refs["appr-btn"].apprRequestPop();
    },
    // 개선창 닫기 후
    imprChange() {
      this.$refs["table"].$refs["compo-table"].resetVirtualScroll();
    },
    loadAssessPlan() {
      this.popupOptions.title = "지난 위험성평가 가져오기";
      this.popupOptions.param = {
        ramTechniqueCd: this.popupParam.ramTechniqueCd,
        jobCategoryCd: this.assessPlan.jobCategoryCd,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/riskOfficeLoadPop.vue"}`);
      this.popupOptions.width = "70%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeLoadPopup;
    },
    closeLoadPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        window.getApp.$emit("CONFIRM", {
          title: "확인",
          message:
            "선택한 평가를 가져오면 현재 입력한 내용은 덮어써집니다. 가져오시겠습니까?",
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            // 복사는 부모(riskDetail)에서 처리
            this.$emit("loadAssess", data[0].ramRiskAssessmentPlanId);
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    addRelateDocument() {
      this.popupOptions.title = "관련자료 검색";
      this.popupOptions.param = {
        type: "multiple",
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/kras/plan/krasRelationDocu.vue"}`);
      this.popupOptions.width = "60%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeRelateDocumentPopup;
    },
    closeRelateDocumentPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        if (!this.assessPlan.relatedDocuments) {
          this.$set(this.assessPlan, "relatedDocuments", []);
        }
        this.$_.forEach(data, (item) => {
          if (
            this.$_.findIndex(this.assessPlan.relatedDocuments, {
              documentId: item.documentId,
              ramDocumentTypeCd: item.ramDocumentTypeCd,
            }) === -1
          ) {
            this.assessPlan.relatedDocuments.splice(0, 0, {
              ramRelatedDocumentId: uid(), // 관련자료 일련번호
              ramRiskAssessmentPlanId: this.assessPlan.ramRiskAssessmentPlanId, // 평가 일련번호
              ramDocumentTypeCd: item.ramDocumentTypeCd, // 문서 분류 코드
              ramDocumentTypeName: item.ramDocumentTypeName, // 문서 분류명
              documentId: item.documentId, // 문서 일련번호
              documentTitle: item.documentTitle, // 문서 제목
              documentSubTitle: item.documentSubTitle, // 문서 부제목
              materialName: item.documentTitle, // 자료명
              editFlag: "C",
              regUserId: this.$store.getters.user.userId,
            });
          }
        });
      }
    },
    addEtc() {
      if (!this.assessPlan.relatedDocuments) {
        this.$set(this.assessPlan, "relatedDocuments", []);
      }
      this.assessPlan.relatedDocuments.splice(0, 0, {
        ramRelatedDocumentId: uid(), // 관련자료 일련번호
        ramRiskAssessmentPlanId: this.assessPlan.ramRiskAssessmentPlanId, // 평가 일련번호
        ramDocumentTypeCd: "RDT0000020", // 문서 분류 코드
        ramDocumentTypeName: "기타", // 문서 분류명
        documentId: "", // 문서 일련번호
        documentTitle: "", // 문서 제목
        documentSubTitle: "", // 문서 부제목
        materialName: "", // 자료명
        editFlag: "C",
        regUserId: this.$store.getters.user.userId,
      });
    },
    deleteRelateDocument() {
      let selectData = this.$refs["docTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$http.url = this.deleteRelateDocumentUrl;
        this.$http.type = "DELETE";
        this.$http.param = {
          data: Object.values(selectData),
        };
        this.$http.request(() => {
          window.getApp.$emit("APP_REQUEST_SUCCESS");
          this.$_.forEach(selectData, (item) => {
            this.assessPlan.relatedDocuments = this.$_.reject(
              this.assessPlan.relatedDocuments,
              item,
            );
          });
          this.$refs["docTable"].$refs["compo-table"].clearSelection();
        });
      }
    },
    getScenarioItems() {
      // 신규등록 : 사용중인 기준항목으로 시나리오 목록 구성
      this.$http.url = selectConfig.ram.riskItem.list.url;
      this.$http.type = "GET";
      this.$http.param = { 
        useFlag: "Y",
        jobCategoryCd: this.assessPlan.jobCategoryCd,
      };
      this.$http.request((_result) => {
        this.assessPlan.scenarios = this.$_.map(_result.data, (item) => {
          return {
            riskOfficeResultId: uid(),
            riskOfficeItemId: item.riskOfficeItemId,
            categoryFst: item.categoryFst,
            categorySnd: item.categorySnd,
            categoryTrd: item.categoryTrd,
            sortOrder: item.sortOrder,
            // assessDate: this.$comm.getToday(),
            // assessUserId: this.$store.getters.user.userId,
            // assessUserName: this.$store.getters.user.userName,
            riskBookFlag: "N",
            editFlag: "C",
            regUserId: this.$store.getters.user.userId,
          };
        });
      });
    },
  },
};
</script>
